import * as colors from '../colors';
var style = {
  100: '1px solid',
  200: '2px solid'
}; // BASE TOKENS

export var normal = {
  100: "".concat(style[100], " ").concat(colors.greys[20]),
  200: "".concat(style[200], " ").concat(colors.greys[20])
};
export var disabled = {
  100: "".concat(style[100], " ").concat(colors.greys[20]),
  200: "".concat(style[200], " ").concat(colors.greys[20])
};
export var active = {
  100: "".concat(style[100], " ").concat(colors.ultraViolets[30]),
  200: "".concat(style[200], " ").concat(colors.ultraViolets[30])
};
export var hover = {
  100: "".concat(style[100], " ").concat(colors.greys[30]),
  200: "".concat(style[200], " ").concat(colors.greys[30])
};
export var error = {
  100: "".concat(style[100], " ").concat(colors.reds[50]),
  200: "".concat(style[200], " ").concat(colors.reds[50])
};
export var focused = {
  100: "".concat(style[100], " ").concat(colors.ultraViolets[70]),
  200: "".concat(style[200], " ").concat(colors.ultraViolets[70])
};
export var selected = {
  100: "".concat(style[100], " ").concat(colors.ultraViolets[70]),
  200: "".concat(style[200], " ").concat(colors.ultraViolets[70])
}; // CONTEXTUAL TOKENS

export var input = {
  normal: normal[100],
  disabled: disabled[100],
  focused: focused[100],
  hover: hover[100],
  error: error[100]
};
export var card = {
  normal: normal[100],
  hover: hover[100],
  focused: focused[100],
  active: active[100],
  selected: selected[100]
};
export var dropdown = {
  normal: normal[100]
};
export var table = {
  row: normal[100]
};
export var checkbox = {
  normal: "".concat(style[200], " ").concat(colors.greys[40]),
  disabled: "".concat(style[200], " ").concat(colors.greys[40]),
  hover: "".concat(style[200], " ").concat(colors.ultraViolets[70]),
  focused: focused[200],
  error: error[200]
};
export var radio = {
  normal: "".concat(style[200], " ").concat(colors.greys[40]),
  disabled: "".concat(style[200], " ").concat(colors.greys[40]),
  hover: "".concat(style[200], " ").concat(colors.ultraViolets[70]),
  focused: focused[200],
  selected: selected[200]
};